import React from "react";
import ReactDOM from "react-dom";
import { Link } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import axios from "axios";
import Loading from "../../components/Loading";
import NoResult from "../../components/general/NoResult";
import Helmet from "react-helmet";
import Tooltip from "rc-tooltip";
import Confirm from "../../components/Confirm.js";
import General from "../../modules/General";
import uuidV4 from "uuid/v4";
import Notification from "../../components/Notification";
import UpgradeRequired from "../../components/UpgradeRequired";
import Select from "react-select";
import Switch from "rc-switch";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import CodeMirror from "react-codemirror";
import "../../../../node_modules/codemirror/mode/htmlmixed/htmlmixed.js";

const product = `<div class="crall-product-item">
	<div class="crall-product-image">
		<a href="{{url}}">
			<img src="{{ image }}">
		</a>
	</div>
	{% if on_sale %}
		<div class="crall-banner">
			<div>{{ percent_off }}%</div>
		</div>
	{% endif %}
	<div class="crall-product-name">{{ name }}</div>
	<div class="crall-price">
		{% if on_sale %}
			<span class="crall-old-price">{{list_price | money:eu }}-</span>
		{% endif %}
		<span class="crall-price">{{price | money:eu }}</span>
	</div>
	<a href="{{url}}" class="crall-buy">Buy</a>
</div>`;

const css = `.crall-product-list {
	overflow: hidden;
	white-space: nowrap;
	position: relative;
}

.crall-product-item {
	width: 100%!important;
	max-width:200px;
	display:inline-block;
	position:relative;
	float:none;
	text-align:center;
	overflow:hidden;
	width:180px;
	transition: left 700ms;
	left:0px;
	margin-left:0px;
}

.crall-old-price {
	text-decoration: line-through;
	color:#ccc;
	padding-right: 5px;
}

.crall-buy {
    padding: 4px 0;
	margin-top:5px;
	display:block;
	background-color: #b26da8;
	border:0;
	color:#fff;
	width: 100%;
	text-decoration:none;
}

.crall-buy:hover {
	color:#ffffff;
}

.crall-banner > div {
	background-color: #f6eaf4;
	width: 200px;
	font-size: 16px;
	margin-left: -60px;
	margin-top: 20px;
	color: #333;
	padding: 4px;
	transform: rotate(-45deg);
	font-weight: bold;
}

.crall-banner {
	position: absolute;
	left: 0px;
	top: 0px;
	width: 200px;
	height: 200px;
	pointer-events: none;
}
`;

class Template extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            isError: false,
            recommendation: {
                id: 0,
                description: "",
                container: "",
                product: product,
                css: css,
                config: '{"spaceBetween":4}'
            }
        };
        this.handleHtmlChange = this.handleHtmlChange.bind(this);

        this.codeMirrorOptions = {
            lineNumbers: true,
            mode: "text/html",
            indentWithTabs: true,
            styleSelectedText: true,
            tabSize: 5,
            indentUnit: 5
        };

        this.codeMirrorOptionsCss = {
            lineNumbers: true,
            mode: "text/css",
            indentWithTabs: true,
            styleSelectedText: true,
            tabSize: 5,
            indentUnit: 5
        };

        this.handleNameChange = this.handleNameChange.bind(this);
        this.save = this.save.bind(this);
    }

    handleHtmlChange(key, code) {
        this.setState({
            recommendation: {
                ...this.state.recommendation,
                [key]: code
            }
        });
    }

    save(closeAfterSave) {
        if (this.state.recommendation.description == "") {
            Notification.error("You need to give this template a description.");
            return false;
        }

        if (this.state.recommendation.config != "") {
            try {
                JSON.parse(this.state.recommendation.config);
            } catch (e) {
                Notification.error('"Slider" is not valid JSON.');
                return false;
            }
        }

        this.setState({
            isLoading: true
        });

        let method = "post";
        let url = "/recommendations/templates";

        if (this.props.recommendationId) {
            method = "put";
            url += "/" + this.props.recommendationId;
        }

        axios[method](url, this.state.recommendation).then(res => {
            Notification.success("Template saved");
            this.setState({
                isLoading: false
            });

            this.props.handleSave(res.data);
            if (closeAfterSave) {
                this.props.onClose();
            }
        });
    }

    handleNameChange(e) {
        this.setState({
            ...this.state,
            recommendation: {
                ...this.state.recommendation,
                description: e.target.value
            }
        });
    }

    componentWillMount() {
        if (this.props.recommendationId) {
            axios
                .get(
                    `/recommendations/templates/${this.props.recommendationId}`
                )
                .then(res => {
                    this.setState({
                        isLoading: false,
                        recommendation: res.data
                    });
                })
                .catch(res => {
                    this.setState({ isError: "Recommendation not found" });
                });
        } else {
            this.setState({
                isLoading: false
            });
        }
    }

    render() {
        if (this.state.isLoading) {
            return <Loading error={this.state.isError} />;
        }

        return (
            <div
                id="recommendation-template"
                className="overview m-t-30 col-sm-8 offset-sm-2 text-center"
            >
                <h1>Template</h1>
                <h2>
                    This will create a recommendation template. You can use this
                    template to show recommendation boxes in your store.
                </h2>
                <div className="m-t-40 col-sm-12">
                    <div className="m-b-20 strike">
                        <span>Description</span>
                    </div>
                    <div className="col-sm-12 p-0 offset-sm-0">
                        <input
                            type="text"
                            onChange={this.handleNameChange}
                            className="form-control form-control-lg"
                            value={this.state.recommendation.description}
                            placeholder="Give this test a description."
                        />
                    </div>
                </div>

                <div className="m-t-40 col-sm-12">
                    <div className="m-b-20 strike">
                        <span>Code</span>
                    </div>
                    <div className="col-sm-12 p-0 offset-sm-0 text-left">
                        <Tabs>
                            <TabList>
                                <Tab>Product HTML</Tab>
                                <Tab>Container HTML</Tab>
                                <Tab>CSS</Tab>
                                <Tab>Advanced</Tab>
                            </TabList>

                            <TabPanel>
                                <CodeMirror
                                    value={this.state.recommendation.product}
                                    onChange={v => {
                                        this.handleHtmlChange("product", v);
                                    }}
                                    options={this.codeMirrorOptions}
                                />
                            </TabPanel>

                            <TabPanel>
                                <CodeMirror
                                    value={this.state.recommendation.container}
                                    onChange={v => {
                                        this.handleHtmlChange("container", v);
                                    }}
                                    options={this.codeMirrorOptions}
                                />
                            </TabPanel>

                            <TabPanel>
                                <CodeMirror
                                    value={this.state.recommendation.css}
                                    onChange={v => {
                                        this.handleHtmlChange("css", v);
                                    }}
                                    options={this.codeMirrorOptionsCss}
                                />
                            </TabPanel>

                            <TabPanel>
                                <CodeMirror
                                    value={this.state.recommendation.config}
                                    onChange={v => {
                                        this.handleHtmlChange("config", v);
                                    }}
                                    options={this.codeMirrorOptions}
                                />
                            </TabPanel>
                        </Tabs>
                    </div>
                </div>

                <div className="col-sm-12 m-t-40 m-b-40 offset-sm-0">
                    <div className="col-sm-6">
                        <button
                            type="button"
                            onClick={() => this.save(false)}
                            className="btn btn-dark btn-block"
                        >
                            Save and continue
                        </button>
                    </div>
                    <div className="col-sm-6">
                        <button
                            type="button"
                            onClick={() => this.save(true)}
                            className="btn btn-dark btn-block"
                        >
                            Save and close
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        auth: state.auth,
        general: state.general
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({}, dispatch);
};

Template = connect(
    mapStateToProps,
    mapDispatchToProps
)(Template);
export default Template;



// WEBPACK FOOTER //
// ./containers/recommendations/template.js